<template>
  <div>
    <loader v-if="loader == true"></loader>
    <div class="row">
      <div class="col-md-12">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Vendedor</legend>
          <div class="row form-group">
            <div class="col-md-12">
              <select name="vendedor" id="vendedor" class="form-control" v-model="proposta.id_vendedor" required>
                <option v-for="vendedor in vendedores" :value="vendedor.id">
                  {{ vendedor.nome_vendedor }}
                </option>
              </select>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-2">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Operação</legend>
          <label>Tipo</label>
          <div class="row form-group">
            <div class="col-md-12">
              <select name="id_tipo_proposta" id="id_tipo_proposta" class="form-control"
                v-model="proposta.id_tipo_proposta" required v-on:change="getMarcas()">
                <option value="1">Automóvel</option>
                <option value="2">Motocicleta</option>
              </select>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-10">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Veículo</legend>
          <div class="row form-group">
            <div class="col-md-3">
              <label for="marcas">Marca</label>
              <select name="marcas" v-model="veiculo.marca" id="marcas" class="form-control" required :disabled="proposta.id_tipo_proposta == '' || !proposta.id_tipo_proposta
                " @change="getModelos()">
                <option v-for="m in marcas" :value="m.Value">
                  {{ m.Label }}
                </option>
              </select>
            </div>
            <div class="col-md-5">
              <label for="veiculo">Veículo</label>
              <select id="veiculo" v-model="veiculo.modelo" class="form-control"
                :disabled="veiculo.marca == '' || !veiculo.marca" required @change="getAnosModelo()">
                <option v-for="m in modelos" :value="m.Value">
                  {{ m.Label }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="modelo">Ano</label>
              <select id="modelo" v-model="veiculo.ano" class="form-control"
                :disabled="veiculo.marca == '' || !veiculo.marca" @change="getVeiculo()" required>
                <option v-for="m in anoModelo" :value="m.Value">
                  {{ m.Label }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label>Valor Fipe <small>R$</small></label>
              <input type="text" v-money="money" name="valor_fipe" id="valor_fipe" readonly
                v-model="proposta.valor_fipe" class="form-control" />
              <input type="hidden" name="valor_fipe" v-model="objeto.valor" class="form-control currency"
                placeholder="0,00" />
              <input type="hidden" name="id_fipe" id="fipe_codigo" v-model="objeto.fipe_id" class="form-control" />
              <input type="hidden" name="ano" id="ano_v" v-model="objeto.ano" class="form-control" />
              <input type="hidden" name="modelo" id="veiculo_modelo" v-model="objeto.modelo" class="form-control" />
              <input type="hidden" name="marca" id="marca_v" v-model="objeto.marca" class="form-control" />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Simulação</legend>
          <div class="row">
            <div class="col-md-6 form-group">
              <label>Valor a Contratar <small>R$</small></label>
              <input type="text" v-money="money" name="valor" :disabled="!veiculo.ano || veiculo.ano == ''" id="valor"
                v-model="proposta.valor_proposta" class="form-control" />
            </div>
            <div class="col-md-6 form-group">
              <label>Valor de Entrada <small>R$</small> {{ entrada }} </label>
              <input type="text" class="form-control" name="entrada" :value="calcEntrada(proposta.valor_proposta, proposta.valor_fipe)
                " style="color: rgb(120, 184, 0) !important" disabled />
            </div>
            <div class="col-md-6 form-group" style="display: none">
              <label>Valor de Retorno <small>R$</small></label>
              <input type="text" v-money="money" name="valor_retorno" :disabled="proposta.id_tipo_proposta == 2 ||
                !veiculo.ano ||
                veiculo.ano == ''
                " id="valor_retorno" v-model="proposta.valor_retorno" class="form-control" />
            </div>
            <div class="col-md-6 form-group">
              <label>N°. Parcelas</label>
              <input type="number" class="form-control" name="paarcelas" id="parcelas" min="1" max="60"
                :disabled="!veiculo.ano || veiculo.ano == ''" required v-model="proposta.parcelas"
                @blur="verificaParcelas()" />
            </div>
            <div class="col-md-6 form-group">
              <label>Dia 1° Parcela</label>
              <datepicker :language="languages.ptBR" v-bind:format="format" input-class="form-control data-parcela"
                name="data_primeira_parcela" id="data_primeira_parcela" :disabledDates="disabledDates"
                placeholder="DD/MM/AAAA" required="required" :disabled="!veiculo.ano || veiculo.ano == ''"
                :open-date="dataMin">
              </datepicker>
            </div>
            <div class="col-md-6 form-group">
              <div class="form-check form-check-inline">
                <label>Bônus</label><br />
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="r0" value="0"
                  :disabled="!veiculo.ano || veiculo.ano == ''" @click="validaRetorno(1)" />
                <label class="form-check-label" for="inlineRadio1"> B0 </label>
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="r1" value="1"
                  :disabled="!veiculo.ano || veiculo.ano == ''" @click="validaRetorno(2)" />
                <label class="form-check-label" for="inlineRadio2"> B1 </label>
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="r2" value="2"
                  :disabled="!veiculo.ano || veiculo.ano == ''" @click="validaRetorno(3)" />
                <label class="form-check-label" for="inlineRadio3"> B2 </label>
                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="r3" value="3"
                  :disabled="!veiculo.ano || veiculo.ano == ''" @click="validaRetorno(4)" />
                <label class="form-check-label" for="inlineRadio3"> B3 </label>
                <template v-if="proposta.id_tipo_proposta != 2">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="r4" value="4"
                    :disabled="!veiculo.ano || veiculo.ano == ''" @click="validaRetorno(5)" />
                  <label class="form-check-label" for="inlineRadio3">
                    B4
                  </label>
                </template>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-md-8">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Proponente</legend>
          <div class="row form-group">
            <div class="col-md-4">
              <label>CPF</label>
              <input type="text" v-mask="['###.###.###-##']" class="form-control" placeholder="000.000.000-00"
                name="cpf" id="cpf" :disabled="!veiculo.ano || veiculo.ano == '' || !isSelectedBonus
                  " v-model="proposta.cpfcnpj" v-on:change="consultaProponente()" required />
            </div>
            <div class="col-md-8">
              <label>Nome</label>
              <input type="text" name="nome" id="nome" class="form-control" v-model="proposta.nome"
                :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj" placeholder="NOME DO PROPONENTE" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 form-group">
              <label for="tipo_renda">Tipo Renda</label>
              <select name="tipo_renda" id="tipo_renda" class="form-control" v-on:change="setAposentado()" required
                :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj" v-model="proposta.tipo_renda">
                <option value="9">AGROPECUÁRIA</option>
                <option value="3">APOSENTADORIA</option>
                <option value="1">PRO-LABORE</option>
                <option value="0">SALÁRIO</option>
                <option value="8">RENDIMENTO NÃO COMPROVADO</option>
              </select>
            </div>
            <div class="col-md-4 form-group">
              <label>Valor Renda R$</label>
              <input type="text" v-money="money" name="renda" id="renda" class="form-control" v-model="proposta.renda"
                :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj" placeholder="RENDA DO PROPONENTE" />
            </div>
            <div class="col-md-4 form-group">
              <label>PA </label>
              <select name="pa_id" id="pa_id" v-model="proposta.pa_id" class="form-control"
                :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj" required>
                <option v-for="p in pas" :value="p.cod_ponto_atendimento" v-if="p.ordenacao != 0">
                  {{ p.nome_ponto_atendimento }}
                </option>
              </select>
            </div>
            <template v-if="loaderCPF == true">
              <div class="col-md-4 form-group">
                <label>Data Nascimento</label>
                <input type="text" class="form-control" placeholder="DD/MM/AAAA" required="required"
                  v-on:blur="validateDate('data_nascimento')" :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj"
                  v-model="proposta.data_nascimento" name="data_nascimento" id="data_nascimento"
                  v-mask="['##/##/####']" />
              </div>
            </template>
            <template v-else>
              <div class="col-md-4 form-group">
                <label>Data Nascimento</label>
                <input class="form-control data-parcela" placeholder="DD/MM/AAAA" required="required" disabled />
              </div>
            </template>
            <div class="col-md-4 form-group">
              <label>Estado civil</label>
              <select name="estado_civil" id="estado_civil" v-model="proposta.estado_civil" class="form-control"
                :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj" required>
                <option value="NÃO INFORMADO">NÃO INFORMADO</option>
                <option value="SOLTEIRO(A)">SOLTEIRO(A)</option>
                <option value="CASADO(A)">CASADO(A)</option>
                <option value="SEPARADO(A)">SEPARADO(A)</option>
                <option value="DIVORCIADO(A)">DIVORCIADO(A)</option>
                <option value="VIÚVO(A)">VIÚVO(A)</option>
                <option value="UNIÃO ESTÁVEL">UNIÃO ESTÁVEL</option>
              </select>
            </div>
            <div class="col-md-8 form-group">
              <label>Naturalidade</label>
              <div class="row">
                <div class="col-md-6">
                  <select name="estado" id="estado" placeholder="Estado" class="form-control"
                    :disabled="proposta.cpfcnpj == '' || !proposta.cpfcnpj">
                    <option value=""></option>
                    <option v-for="e in estados" :value="e.id">
                      {{ e.nome }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select name="cidade" id="cidade" class="form-control"
                    :disabled="proposta.estado == '' || !proposta.estado" @change="validaCidade()">
                    <option value=""></option>
                    <option v-for="c in municipios" :value="c.id">
                      {{ c.nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4 form-group">
              <label>Data inicio emprego</label>
              <select class="form-control" id="data_inicio_emprego" placeholder="DD/MM/AAAA" required="required"
                v-model="proposta.data_inicio_emprego" name="data_inicio_emprego">
                <template v-if="!isFeirao">
                  <option value="1">Menos de 1 ano</option>
                  <option value="2">Mais de 1 ano</option>
                </template>
                <template v-else>
                  <option value="1">Menos de 6 meses</option>
                  <option value="2">Mais de 6 meses</option>
                </template>
              </select>
            </div>
            <div class="row form-group">
              <div class="col-md-4">
                <label>Idade</label>
                <input type="text" class="form-control" placeholder="Idade" name="idade" id="idade" disabled
                  :value="proposta.idade + ' anos'" />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row" align="center">
      <div class="col-md-12">
        <button class="btn btn-success btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg" @click="save()"
          :disabled="!proposta.cpfcnpj || proposta.cpfcnpj == '' || !isSelectedBonus || !apto
            ">
          Continuar
        </button>
        <router-link :to="{ name: 'IndexPropostas' }"
          class="btn btn-default btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg">
          Cancelar</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { VMoney } from "v-money";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
var moment = require("moment");

window.addEventListener("beforeunload", function (e) {
  e.preventDefault();
  e.returnValue = "";
});

export default {
  name: "form-proposta",

  directives: {
    mask,
    money: VMoney,
  },

  components: {
    Datepicker,
  },

  data() {
    return {
      aposentado: false,
      solicitaRetorno: true,
      dataMin: moment(moment().add(31, "days").calendar(), "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
      dataLimite: this.getDiasLimite(),
      dataIni: new Date(),
      dataAtual: moment().format("YYYY-MM-DD"),
      anoAtual: moment().format("yyyy"),
      disabledDates: {
        daysOfMonth: [
          1, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14, 16, 17, 18, 19, 20, 21, 22,
          23, 24, 25, 26, 27, 28, 29, 30, 31,
        ], // Disable 29th, 30th and 31st of each month
      },
      defaultDate: this.dataLimite,
      language: "pt-br",
      languages: lang,
      format: "dd/MM/yyyy",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " ",
        precision: 2,
        masked: true,
      },
      limiteRetorno: localStorage.retorno != null ? localStorage.retorno : 3,
      seguro: localStorage.seguro,
      cooperado: 0,
      loader: false,
      entrada: "",
      anoBase: moment().format("YYYY") - 15,
      proposta: {},
      objeto: {},
      pas: [],
      marcas: [],
      veiculo: {},
      modelos: [],
      anoModelo: [],
      estados: [],
      loaderCPF: false,
      municipios: [],
      isSelectedBonus: false,
      isFeirao: false,
      apto: true,
      idLojista: localStorage.userid,
      vendedores: [],
    };
  },

  mounted() {
    this.getVersionSystem();
    this.getVendedores();
    this.getPas();

    this.disabledDates.to = new Date(this.dataAtual);
    this.disabledDates.from = new Date(this.dataLimite);

    this.proposta.parcelas = 12;
    var $this = this;
    $this.getEstados();

    $("#modelo")
      .select2()
      .change(function () {
        $this.veiculo.ano = $(this).val();
        $this.getVeiculo();
      });

    $("#veiculo")
      .select2()
      .change(function () {
        $this.veiculo.ano = null;
        $this.veiculo.modelo = $(this).val();
        $this.getAnosModelo();
      });

    $("#marcas")
      .select2()
      .change(function () {
        $this.veiculo.marca = $(this).val();
        $this.getModelos();
      });

    $("#id_tipo_proposta")
      .select2()
      .change(function () {
        $this.proposta.id_tipo_proposta = $(this).val();
        $this.getMarcas();
      });

    $("#estado")
      .select2({
        placeholder: "Estado",
      })
      .change(function () {
        $this.proposta.estado = $(this).val();
        $this.getCidades();
      });

    $("#cidade")
      .select2({
        placeholder: "Cidade",
      })
      .change(function () {
        $this.proposta.cidade = $(this).val();
      });
  },

  methods: {
    getDataFeirao: function () {
      var $this = this;
      let data = moment().format("YYYY-MM-DD");
      $this.$http.get("/propostas/isFeira").then(function (response) {
        if (response.data.data_inicio != 0 && response.data.data_fim != 0) {
          let dataFeirao = [response.data.data_inicio, response.data.data_fim];
          if (dataFeirao.indexOf(data) != "-1") {
            $this.isFeirao = true;
            return;
          }
        }
        $this.isFeirao = false;
      });
    },

    getVersionSystem: function () {
      var $this = this;
      $this.$http.get("/propostas/versao").then(function (response) {
        if (17 != parseFloat(response.data[0]["versao"])) {
          swal({
            title: "Atenção!",
            text: "Versão do sistema foi atualizada. Por favor pressione as teclas 'Ctrl + F5', para atualizar o cache do navegador",
            type: "error",
            confirmButtonText: "Ok",
          }).then((willDelete) => {
            if (willDelete.value) {
              $this.$router.push({ path: "/" });
            }
          });
        }
      });
    },
    getDiasLimite: function () {
      var data = moment().format("YYYY-MM-DD");
      var dataIni = moment("2022-12-01").format("YYYY-MM-DD");
      var dataFin = moment("2022-12-31").format("YYYY-MM-DD");
      if (data >= dataIni && data <= dataFin) {
        return moment(
          moment().add(121, "days").calendar(),
          "MM-DD-YYYY"
        ).format("YYYY-MM-DD");
      }
      return moment(moment().add(61, "days").calendar(), "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      );
    },

    validateDate: function (data) {
      var data = $("#" + data).val();
      var dia = data.substring(0, 2);
      var mes = data.substring(3, 5);
      var ano = data.substring(6, 10);

      //Criando um objeto Date usando os valores ano, mes e dia.
      var novaData = new Date(ano, mes - 1, dia);

      var mesmoDia = parseInt(dia, 10) == parseInt(novaData.getDate());
      var mesmoMes = parseInt(mes, 10) == parseInt(novaData.getMonth()) + 1;
      var mesmoAno = parseInt(ano) == parseInt(novaData.getFullYear());

      if (!(mesmoDia && mesmoMes && mesmoAno)) {
        this.$toastr("warning", " Data  informada é inválida", "Atenção!");

        return false;
      }
      return true;
    },

    validaCidade: function (data) { },

    setAposentado: function () {
      if ($("#tipo_renda").val() == "3") {
        this.proposta.tipo_renda = "3";
        $("#data_inicio_emprego").prop("disabled", true);
        $("#data_inicio_emprego").val(2);
        this.aposentado = true;
      } else {
        this.aposentado = false;
        $("#data_inicio_emprego").prop("disabled", false);
        this.proposta.tipo_renda = this.proposta.tipo_renda;
      }
    },

    getEstados: function () {
      var $this = this;

      $this.$http.get("/sistema/estados").then(function (response) {
        $this.estados = response.data;
      });
    },

    getCidades: function () {
      var $this = this;

      $this.municipios = [];

      $this.$http
        .get("/sistema/estados/" + $this.proposta.estado + "/cidades")
        .then(function (response) {
          $this.municipios = response.data;
        });
    },

    verificaParcelas: function () {
      let anos = (this.anoAtual - this.veiculo.ano.substring(0, 4));

      if (this.proposta.parcelas > 60) {
        $("#parcelas").val(60);
        this.proposta.parcelas = 60;
        return this.$toastr(
          "warning",
          "Número de parcelas deve ser de 1 a 60.",
          "Atenção!"
        );
      }

      if (anos >= 11 && this.proposta.parcelas > 48) {
        $("#parcelas").val(48);
        this.proposta.parcelas = 48;
        return this.$toastr(
          "warning",
          "Número máximo de parcelas para veículos de 11 a 15 anos (48x)",
          "Atenção!"
        );
      }

      if (this.proposta.parcelas < 1) {
        $("#parcelas").val(1);
        this.proposta.parcelas = 1;
        return this.$toastr(
          "warning",
          "Número de parcelas deve ser de 1 a 60.",
          "Atenção!"
        );
      }
    },

    logout() {
      var $this = this;
      $this.$http.get("/logout").then(function (response) {
        localStorage.setItem("token", null);
        localStorage.setItem("username", null);
        localStorage.setItem("seguro", null);
        localStorage.setItem("feirao", null);
        $this.$router.push({ name: "Login" });
      });
    },

    save: function () {
      if (this.proposta.id_vendedor == undefined) {
        return this.$toastr(
          "warning",
          "O campo Vendedor é obrigatório.",
          "Atenção!"
        );
      }
      var $this = this;
      var dataPrimeiraParcela = $("#data_primeira_parcela").val().split("/");
      $this.proposta.data_primeira_parcela =
        dataPrimeiraParcela[2] +
        "-" +
        dataPrimeiraParcela[1] +
        "-" +
        dataPrimeiraParcela[0];

      var cpf = this.proposta.cpfcnpj;
      cpf = cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "");

      var valido = this.$utils.validaCPF(cpf);

      if (valido == false) {
        return this.$toastr(
          "warning",
          "CPF informado é inválido " + $this.proposta.cpfcnpj + ".",
          "Atenção!"
        );
      }

      if ($("#data_primeira_parcela").val() == "") {
        $("#data_primeira_parcela").focus();
        return this.$toastr(
          "warning",
          "Data da primeira parcela é obrigatório.",
          "Atenção!"
        );
      }

      if ($("#tipo_renda").val() == "") {
        $("#tipo_renda").focus();
        return this.$toastr(
          "warning",
          "O campo Fonte Renda é obrigatório.",
          "Atenção!"
        );
      }

      if ($("#estado").val() == "") {
        return this.$toastr(
          "warning",
          "Estado não informado. Verifique!",
          "Atenção!"
        );
      }

      if ($("#cidade").val() == "") {
        return this.$toastr(
          "warning",
          "Cidade não informada. Verifique!",
          "Atenção!"
        );
      }

      if ($("#tipo_renda").val() == "3") {
        $("#data_inicio_emprego").val(2);
      }

      if ($("#tipo_renda").val() != "3") {
        if ($("#data_inicio_emprego").val() == null) {
          return this.$toastr(
            "warning",
            "Campo Data inicio emprego é de preenchimento obrigatório!",
            "Atenção!"
          );
        }
      }

      if ($("#cidade").val() == "") {
        return this.$toastr(
          "warning",
          "Cidade não informada. Verifique!",
          "Atenção!"
        );
      }

      if (
        this.proposta.valor_retorno == "" ||
        this.proposta.valor_retorno == null ||
        !this.proposta.valor_retorno ||
        this.solicitaRetorno == true
      ) {
        var valor_retorno = this.proposta.valor_retorno;
        valor_retorno = valor_retorno
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");
        // if(parseFloat(valor_retorno) == 0 || parseFloat(valor_retorno) == 0.00) {
        //   this.solicitaRetorno = false;
        //   return this.$toastr('warning', 'Confirme o valor de retorno que será aplicado a está simulação.', 'Atenção!');
        // }
      }

      if ($this.proposta.pa_id == null || $this.proposta.pa_id == "") {
        $("#pa_id").focus();
        return this.$toastr("warning", "O campo PA é obrigatório.", "Atenção!");
      }

      if ($("#data_nascimento").val() == "") {
        $("#data_nascimento").focus();
        return this.$toastr(
          "warning",
          "O campo DATA NASCIMENTO é obrigatório.",
          "Atenção!"
        );
      }

      if (
        $this.proposta.estado_civil == null ||
        $this.proposta.estado_civil == ""
      ) {
        $("#estado_civil").focus();
        return this.$toastr(
          "warning",
          "O campo ESTADO CIVIL é obrigatório.",
          "Atenção!"
        );
      }

      $this.proposta.objeto = {};
      $this.proposta.objeto = $this.objeto;
      $this.proposta.cooperado = $this.cooperado;
      $this.loader = true;

      if ($this.proposta.id_tipo_proposta == 3) {
        $this.proposta.tipo_proposta_id = 1;
      } else {
        $this.proposta.tipo_proposta_id = $this.proposta.id_tipo_proposta;
      }
      this.proposta.valor_alienacao = 400;
      this.proposta.data_nascimento = $("#data_nascimento ").val();

      $this.$http
        .post("/propostas/simular", $this.proposta)
        .then(function (response) {
          if (response.data == "inativo") {
            $this.$toastr("warning", "Simulação não Efetivada.", "Atenção!");
            $this.logout();
          }

          if (response.data.proposta.data.aprovacao_automatica == false) {
            $this.$toastr(
              "warning",
              "Confirme os dados e em seguida encaminhe a simulação para analise.",
              "Atenção!"
            );
          }

          $this.loader = false;

          return $this.$router.push({
            name: "EditarProposta",
            params: { id: response.data.proposta.data.id, origem: "S" },
          });
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    validaRetorno: function (tipo) {
      var $this = this;
      var valorProposta = this.proposta.valor_proposta + " ";
      valorProposta = valorProposta
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");
      var valorRetorno = this.proposta.valor_retorno + " ";
      valorRetorno = valorRetorno
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");

      if (parseFloat(valorProposta).toFixed(2) > 0.0) {
        //if (parseFloat((parseFloat(valorRetorno) * 100) / parseFloat(valorProposta)).toFixed(2) > parseFloat(this.limiteRetorno)) {
        $this.$http
          .get("/lojista/limiteretorno/" + tipo)
          .then(function (response) {
            if (response.data[0].percentual > 0) {
              var valorPermitido =
                (response.data[0].percentual / 100) * parseFloat(valorProposta);
              $this.proposta.valor_retorno = valorPermitido.toFixed(2);
            } else {
              $this.proposta.valor_retorno = 0;
            }
            $this.isSelectedBonus = true;
          });
        //return this.$toastr('warning', 'Valor máximo de retorno permitido R$' + this.$utils.numberToReal(valorPermitido), 'Atenção!');
        // }
      }
    },

    calcEntrada: function (valorProposta, valorFipe) {
      var valorProposta = valorProposta + " ";
      valorProposta = valorProposta
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");

      var valorFipe = valorFipe + " ";
      valorFipe = valorFipe
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");

      var entrada = parseFloat(valorFipe) - parseFloat(valorProposta);

      if (entrada <= 0) {
        return "0,00";
      }

      return this.$utils.numberToReal(entrada);
    },

    consultaProponente: function () {
      var $this = this;
      var cpf = this.proposta.cpfcnpj;
      cpf = cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "");

      var valido = this.$utils.validaCPF(cpf);

      if (valido == false) {
        return this.$toastr(
          "warning",
          "CPF informado é inválido " + $this.proposta.cpfcnpj + ".",
          "Atenção!"
        );
      }
      $this.loaderCPF = false;
      $this.loader = true;

      $this.proposta.cpfcnpj = $this.proposta.cpfcnpj
        .replaceAll(".", "")
        .replace("-", "");
      $this.$http
        .get("/cpf/" + $this.proposta.cpfcnpj)
        .then(function (response) {
          $("#nome").val("").removeAttr("disabled");
          $("#tipo_renda").val("").removeAttr("disabled");
          $("#pa_id").val("").removeAttr("disabled");
          $("#data_nascimento").removeAttr("disabled");
          $("#estado_civil").val("").removeAttr("disabled");
          // $('#naturalidade').val('').removeAttr('disabled');
          $("#data_inicio_emprego").val(1).removeAttr("disabled");
          $this.proposta.nome = "";
          $this.proposta.tipo_renda = "";
          $this.cooperado = 0;
          $this.proposta.pa_id = null;
          $this.proposta.data_nascimento = null;
          $this.proposta.idade = null;
          $this.loader = false;

          if (response.data.CLIENTE) {
            $this.apto = true;
            if (response.data.CLIENTE.APTO == 0) {
              $this.apto = false;
              return $this.$toastr(
                "warning",
                "Lançamento não permitido! <br> Para maiores informações entre em contato com o setor responsável"
              );
            }
            if (response.data.CLIENTE.DESCNOMECLIENTE) {
              if (response.data.CLIENTE.NUMCONTACORRENTE != null) {
                $this.cooperado = 1;
                $this.proposta.pa_id = response.data.CLIENTE.IDUNIDADEINST;
                $("#pa_id").attr("disabled", true);
              }

              $("#nome")
                .val(response.data.CLIENTE.DESCNOMECLIENTE)
                .attr("disabled", true);
              $this.proposta.nome = response.data.CLIENTE.DESCNOMECLIENTE;

              setTimeout(function () {
                if (response.data.CLIENTE.DATANASCIMENTO != null) {
                  $this.proposta.data_nascimento = $this.$utils.formatDate(
                    response.data.CLIENTE.DATANASCIMENTO
                  );
                  $this.proposta.idade =
                    $this.$utils.formatDate(new Date(), "YYYY") -
                    $this.$utils.formatDate(
                      response.data.CLIENTE.DATANASCIMENTO,
                      "YYYY"
                    );
                }
                setTimeout(function () {
                  $this.loaderCPF = true;
                  setTimeout(function () {
                    $("#data_nascimento").attr("disabled", true);
                  }, 100);
                }, 100);
              }, 100);

              if (response.data.CLIENTE.ESTADOCIVIL != null) {
                $("#estado_civil")
                  .val(response.data.CLIENTE.ESTADOCIVIL)
                  .attr("disabled", true);
                $this.proposta.estado_civil = response.data.CLIENTE.ESTADOCIVIL;
              }

              if (response.data.CLIENTE.FONTERENDA != null) {
                $("#tipo_renda").val(
                  response.data.CLIENTE.FONTERENDA.CODTIPOFONTERENDA
                );
                $this.proposta.tipo_renda =
                  response.data.CLIENTE.FONTERENDA.CODTIPOFONTERENDA;
              }
            }
          }
          setTimeout(function () {
            $this.loaderCPF = true;
          }, 400);
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    getPas: function () {
      var $this = this;
      $this.$http.get("/pas").then(function (response) {
        $this.pas = response.data;
      });
    },

    alteraEstadoCivil: function () {
      this.proposta.estado_civil == $("#estado_civil").val();
    },

    getModelos: function () {
      this.modelos = [];

      var tipo = "";
      if (this.proposta.id_tipo_proposta == 1) {
        tipo = 1;
      } else if (this.proposta.id_tipo_proposta == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;

      $this.$http
        .get("/fipe/modelos/" + tipo + "/" + $this.veiculo.marca)
        .then(function (response) {
          let anos = response.data["Anos"];

          if (tipo == 1) {
            anos.map((ano, index) => {
              if (ano.Label < moment().format("YYYY") - 15) {
                anos.slice(index, 1);
              }
            });
          }
          if (tipo == 2) {
            anos.map((ano, index) => {
              if (ano.Label < moment().format("YYYY") - 15) {
                anos.slice(index, 1);
              }
            });
          }

          $this.modelos = response.data["Modelos"];
          $this.anoModelo = anos;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAnosModelo: function () {
      var $this = this;
      if ($this.veiculo.ano) {
        if ($this.veiculo.ano != "") {
          $this.getVeiculo();
        }
      }

      var tipo = "";
      if (this.proposta.id_tipo_proposta == 1) {
        tipo = 1;
      } else if (this.proposta.id_tipo_proposta == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var veiculo = $this.veiculo.modelo;

      $this.anoModelo = [];
      $this.loader = true;

      $this.$http
        .get(
          "/fipe/anomodelo/" + tipo + "/" + $this.veiculo.marca + "/" + veiculo
        )
        .then(function (response) {
          let anos = response.data;
          let anosModelo = [];
          if (tipo == 1) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                parseInt(moment().format("YYYY") - 15) ||
                parseInt(anos[index].Label) == 0
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }

          if (tipo == 2) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                parseInt(moment().format("YYYY") - 15) ||
                parseInt(anos[index].Label) == 0
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }

          // $this.anoModelo = tipo == 2 ? anosModelo : anos;
          $this.anoModelo = anosModelo;
          $this.loader = false;
        });
    },

    getModelosAno: function () {
      var $this = this;
      var tipo = "";

      if (this.proposta.id_tipo_proposta == 1) {
        tipo = 1;
      } else if (this.proposta.id_tipo_proposta == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      $this.loader = true;

      $this.$http
        .get(
          "/fipe/modeloanomodelo/" +
          tipo +
          "/" +
          $this.veiculo.marca +
          "/" +
          $this.veiculo.ano
        )
        .then(function (response) {
          $this.modelos = response.data;
          $("#veiculo").select2("open").trigger("focus");
          $this.loader = false;
        });
    },

    getVeiculo: function () {
      this.objetoS = {};

      var tipo = "";
      if (this.proposta.id_tipo_proposta == 1) {
        tipo = 1;
      } else if (this.proposta.id_tipo_proposta == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;
      $this.loader = true;

      if (
        !$this.veiculo.modelo ||
        $this.veiculo.modelo == "" ||
        $this.veiculo.modelo == null
      ) {
        return $this.getModelosAno();
      }

      var veiculo = $this.veiculo.modelo;

      $this.$http
        .get(
          "/fipe/paramsmodelo/" +
          tipo +
          "/" +
          $this.veiculo.marca +
          "/" +
          veiculo +
          "/" +
          $this.veiculo.ano
        )
        .then(function (response) {
          $this.objeto.marca = response.data.Marca;
          $this.objeto.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.proposta.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.objeto.modelo = response.data.Modelo;
          $this.objeto.ano = response.data.AnoModelo;
          $this.objeto.fipe_id = response.data.CodigoFipe;
          $this.objeto.tipo_combustivel = response.data.Combustivel;
          //$("#data_primeira_parcela").val("15/06/2023").trigger("change");
          $this.loader = false;
        });
    },

    getMarcas: function () {
      var tipo = "";
      if (this.proposta.id_tipo_proposta == 1) {
        tipo = 1;
      } else if (this.proposta.id_tipo_proposta == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;
      $this.getDataFeirao();
      $this.marcas = [];
      $this.loader = true;

      $this.$http.get("/fipe/marcas/" + tipo).then(function (response) {
        $this.marcas = response.data;
        $this.loader = false;
      });
    },

    getVendedores: function () {
      var $this = this;
      $this.loader = true;

      $this.$http.post("/lojista/getVendedores/", { id_lojista: this.idLojista }).then(function (response) {
        $this.vendedores = response.data;
        $this.loader = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/propostas/_form.vue